import type { ChatMessageListResponsePageAllOfThreeContentItemAllOf } from './chatMessageListResponsePageAllOfThreeContentItemAllOf';
import type { ChatMessageListResponsePageAllOfThreeContentItemAllOfOnezero } from './chatMessageListResponsePageAllOfThreeContentItemAllOfOnezero';

export type ChatMessageListResponsePageAllOfThreeContentItem = ChatMessageListResponsePageAllOfThreeContentItemAllOf & ChatMessageListResponsePageAllOfThreeContentItemAllOfOnezero;
